module.exports = __webpack_public_path__ + "img/invalid.33a666b9.png";